import React, { useState } from 'react';
import { 
  Box, 
  TextField, 
  Button, 
  Paper, 
  Typography, 
  IconButton, 
  InputAdornment, 
  Tooltip,
  Stack
} from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon, CloudUpload as UploadIcon } from '@mui/icons-material';
import { CarImportSearchParams } from '../api/apiClient';

interface CarImportSearchProps {
  onSearch: (params: CarImportSearchParams) => void;
}

export const CarImportSearch: React.FC<CarImportSearchProps> = ({ 
  onSearch 
}) => {
  const [searchParams, setSearchParams] = useState<CarImportSearchParams>({
    make: '',
    model: '',
    year_from: undefined,
    year_to: undefined,
    fuel_type: '',
    page: 0,
    limit: 10
  });
  const [fileKey, setFileKey] = useState(Date.now());

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSearchParams(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchParams);
  };

  const handleClear = () => {
    const clearedParams = {
      make: '',
      model: '',
      year_min: undefined,
      year_max: undefined,
      skip: 0,
      limit: 10
    };
    setSearchParams(clearedParams);
    onSearch(clearedParams);
  };


  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Search Car Imports
      </Typography>
      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <TextField
              label="Make"
              name="make"
              value={searchParams.make || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              sx={{ minWidth: 200 }}
            />
            <TextField
              label="Model"
              name="model"
              value={searchParams.model || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              sx={{ minWidth: 200 }}
            />
            <TextField
              label="Min Year"
              name="year_from"
              type="number"
              value={searchParams.year_from || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              sx={{ minWidth: 120 }}
              inputProps={{ min: 1900, max: 2100 }}
            />
            <TextField
              label="Max Year"
              name="year_to"
              type="number"
              value={searchParams.year_to || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              sx={{ minWidth: 120 }}
              inputProps={{ min: 1900, max: 2100 }}
            />
            <TextField
              label="Fuel Type"
              name="fuel_type"
              value={searchParams.fuel_type || ''}
              onChange={handleInputChange}
              variant="outlined"
              size="small"
              sx={{ minWidth: 150 }}
              placeholder="e.g. Bensin, Diesel"
            />
          </Box>
          
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Button
                type="submit"
                variant="contained"
                startIcon={<SearchIcon />}
              >
                Search
              </Button>
              <Button
                type="button"
                variant="outlined"
                startIcon={<ClearIcon />}
                onClick={handleClear}
              >
                Clear
              </Button>
            </Box>
            
          </Box>
        </Stack>
      </form>
    </Paper>
  );
};
